<template>
<div>
  <div  class="ndata-footer"  style="background-color:#343434;padding: 40px 0px;">
    <el-row :gutter="20" style="letter-spacing: 1px;">
      <el-col :span="9" :offset="3">
        <div class="company-name" v-if="siteIntro" >主办单位:{{siteIntro}}</div>
        <div class="company-name" v-if="websit && websit.guidance" >指导单位：{{websit.guidance}}</div>
        <div class="company-name" v-if="websit && websit.undertake" >承办单位：{{websit.undertake}}</div>
        <div class="company-name" v-if="websit && websit.siteAddress" >地址：{{websit.siteAddress}}</div>
        <div class="company-name" v-if="websit && websit.zipCode" >邮编：{{websit.zipCode}}</div>
        <div class="company-name" v-if="websit && websit.contactTelephone" >电话：{{websit.contactTelephone}}</div>
        <div class="company-name" v-if="websit && websit.contactMail" >邮箱：{{websit.contactMail}}</div>
        <div class="company-name" style="margin: 10px 0px;">
          战略合作:
          <span>美亚联创（北京）科技有限公司</span>
        </div>
        <div class="company-name" style="margin: 10px 0px;">
          运营服务:
          <span v-if="websit && websit.technicalSupport">{{websit.technicalSupport}}</span>
          <span v-else>恩数互联（北京）智能科技有限公司</span>
        </div>
        <div class="company-name">京ICP备19032597号-7</div>
      </el-col>
<!--      todo 放大-->
      <el-col :span="9" v-if="websit">
        <div class="code-img" v-if="websit.officialAccountPath">
          <img :src="websit.officialAccountPath" class="smooth-zoom"/>
        </div>
        <div class="code-font" v-if="websit.officialAccountPath">
          公众号二维码
        </div>

        <div class="code-img" v-if="websit.appletPath">
          <img :src="websit.appletPath" class="smooth-zoom"/>
        </div>
        <div class="code-font" v-if="websit.appletPath">
          移动端二维码
        </div>

        <div class="code-img" v-if="websit.customerServicePath">
          <img :src="websit.customerServicePath" class="smooth-zoom"/>
        </div>
        <div class="code-font" style="margin-top: 10px;" v-if="websit.customerServicePath">
          客服二维码
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import QRCode from 'qrcodejs2'
import constant from '../constant'
export default {
  props: {
    topHeight: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      marginTopHeight: 10,
      year: new Date().getFullYear(),
      dictInfo: {},
      isMobile: null,
      // qrUrl: constant.STUDENT_PATH + '/student/index.action'
      qrUrl: constant.URL_DOWN + '/studycenter'
    }
  },
  computed: {
    ...mapGetters(['footerList', 'siteIntro', 'websit'])
  },
  watch: {
    topHeight: {
      handler (val) {
        this.marginTopHeight = val
      },
      immediate: true
    }
  },
  created () {
    this.ismobile()
    // setTimeout(() => {
    //   this.qrCodeGeneration()
    // }, 300)
  },
  mounted () {
    this.$nextTick(function () {
      // this.qrCodeGeneration()
    })
  },
  methods: {
    ismobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      this.isMobile = flag
    },
    // 二维码生成
    qrCodeGeneration () {
      // if (this.websit) {
      //   this.qrUrl = this.websit.siteDomain + '/studycenter'
      // }
      // 生成二维码
      this.$nextTick(function () {
        document.getElementById('qrCodeUrl').innerHTML = ''
        let qrCodeUrl = new QRCode('qrCodeUrl', {
          width: 140,
          height: 140,
          text: this.qrUrl,
          colorDark: '#000000',
          colorLight: '#fff'
        })
        console.log(qrCodeUrl)
      })
    }
  }
}
</script>

<style scoped>
.company-name{
  font-weight: normal;
  font-size: 14px;
  color: #FFFFFF;
}
.code-font{
  writing-mode: vertical-lr;
  font-weight: bold;
  font-size: 13px;
  color: #BEBEBE;
  float: right;
  margin: 3px 6px 0px 20px;
}
.smooth-zoom {
  width: 100%;
  border-radius: 4px;
  transition: transform 0.3s ease;
  display: block; /* 确保 transform 正常工作 */
}

.smooth-zoom:hover {
  transform: scale(1.8) translateY(-15px); /* 放大 + 向上移动 */
}
.code-img{
  width: 90px;
  height: 90px;
  background-color:#D9D9D9;
  border-radius: 4px;
  float:right;
}
</style>



// WEBPACK FOOTER //
// src/components/footerV2.vue